<template>
    <div>
        <v-icon class="mdi mdi-magnify search-icon"/>
        <input :id="id" :placeholder="placeholder" v-model="searchValue" @input="handleSearch" class="search-input">
        <!-- <TextButton @click="handleSearch" buttonText="검색" Black class="ml-2" /> -->
    </div>
</template>

<script>
import TextButton from '@/components/ui/button/TextButton2.vue';

import { mapActions } from 'vuex';

export default {
    components: {
        TextButton,
    },
    props: {
        id: String,
        placeholder: {
            type: String,
            default() {
            return this.$store.getters.t('동영상 제목 또는 태그로 동영상 찾기');
            }
        }
    },
    data() {
        return {
            searchValue: ''
        };
    },
    computed: {
        searchQuery: {
            get() {
                return this.$store.state.search.searchQuery;
            },
            set(value) {
                this.updateSearchQuery(value);
            }
        }
    },
    methods: {
        ...mapActions('search', ['updateSearchQuery']),
        handleSearch() {
            this.updateSearchQuery(this.searchValue);
            //this.$emit('updateSearchQuery', this.searchValue)
        }
    }
};
</script>

<style scoped>
.search-input {
    width: 70%;
    height: 36px;
    padding: 8px;
    margin-bottom: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    background: #fff;
    padding-left: 36px;
}
input .placeholder{
    margin-left: 20px;
}

input:focus {
    outline: none;
    border: 1px solid #999;
}

.search-icon {
    position: absolute;
    margin-left: 10px;
    margin-top: 6px;
    color: #aaa;
}
</style>
